import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { Tooltip } from 'react-tippy'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import applicationConstants from '../../../../../../utils/constants/application'
import { getCompanyLogoUrl } from '../../../../../../utils/routing/externalLinks'
import { capitalize } from '../../../../../../utils/string/index'
import numberConverter from '../../../../../../utils/tuition/numberForCurrency'
import { getInsTokenModules } from '../../../../../unauthenticated/Onboarding/insTokenDuck'

class CompanyCard extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    skills: PropTypes.any.isRequired,
    avgSalary: PropTypes.any.isRequired,
    isMobile: PropTypes.bool.isRequired,
    companySearchEnabled: PropTypes.bool.isRequired,
    addCompanyToSearch: PropTypes.func,
    insTokenModules: PropTypes.array,
  }

  render() {
    const {
      name,
      companyId,
      skills,
      avgSalary,
      isMobile,
      addCompanyToSearch,
      companySearchEnabled,
      insTokenModules,
    } = this.props
    const addDefaultSrc = e => {
      if (e.target.src !== applicationConstants.building_icon_url) {
        e.target.src = applicationConstants.building_icon_url
      }
    }
    const topSkills = isMobile ? skills.slice(0, 5) : skills

    const jobBoardEnabled = insTokenModules && insTokenModules.includes('Job-Board')

    return (
      <div key={name}>
        <div style={{ margin: isMobile ? '0 20px' : 'unset', float: 'left' }}>
          <div className="company-logo-container">
            <img
              src={getCompanyLogoUrl(companyId)}
              alt="company logo"
              className="company-logo"
              onError={addDefaultSrc}
            />
          </div>
          {jobBoardEnabled && (
            <div style={{ fontSize: 14, marginTop: 10 }}>
              <Link to={`/app/jobs?keywords=${encodeURIComponent(name)}`}>
                <i className="fal fa-external-link" /> Open Jobs
              </Link>
            </div>
          )}
        </div>

        <div
          style={{
            marginLeft: '100px',
            textTransform: 'capitalize',
          }}
        >
          <h3 style={{ marginBottom: isMobile ? '0' : '8px' }}>{capitalize(name)}</h3>
          {avgSalary && (
            <div style={{ marginBottom: 5 }}>
              <span style={{ color: '#303d48' }}>Average Salary: </span>
              <b style={{ color: 'green' }}>${numberConverter(avgSalary)}</b>
            </div>
          )}
          <div style={{ fontSize: 12 }}>
            <span style={{ color: '#303d48' }}>Top Skills: </span>
            {topSkills.map((skill, index) => (
              <span key={skill}>
                {index !== 0 && ', '}
                {skill}
              </span>
            ))}
          </div>
          {companySearchEnabled && (
            <Tooltip
              title={`Add ${capitalize(name)} to search`}
              style={{
                textAlign: 'right',
                display: 'block',
              }}
            >
              <a onClick={() => addCompanyToSearch(name)} style={{ color: '#30bc9d' }}>
                <i className="fal fa-search" />
              </a>
            </Tooltip>
          )}
        </div>
      </div >
    )
  }
}

const mapStateToProps = () => {
  return state => ({
    insTokenModules: getInsTokenModules(state),
  })
}

export default connect(mapStateToProps)(CompanyCard)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/components/CompanyCard.js